module.exports = __webpack_public_path__ + "img/programs-icon-1.37cfa5e3.png";